import { ActionTypes } from 'state/actions/alert';
import { IAlert } from 'components/atoms/Alert';
import { IReducerAction } from 'models/context';

interface IState {
  roleAlert: IAlert | null;
  dictionaryAlert: IAlert | null;
  legalEntityAlert: IAlert | null;
  legalEntityOrgAlert: IAlert | null;
  legalEntityActivateAlert: IAlert | null;
  legalEntityDeactivationWarningsAlert: IAlert | null;
  taskAlert: IAlert | null;
  intelligenceReportAlert: IAlert | null;
  documentAlert: IAlert | null;
  authAlert: IAlert | null;
  userAlert: IAlert | null;
  samePageAlert: IAlert | null;
  apiAlert: IAlert | null;
  nextPageAlert: IAlert | null;
  transactionAlert: IAlert | null;
  ancillaryAlert: IAlert | null;
  trustedDeviceAlert: IAlert | null;
  firearmAlert: IAlert | null;
  accessoryAlert: IAlert | null;
  ammunitionAlert: IAlert | null;
  componentAlert: IAlert | null;
  auditLogSamePageAlert: IAlert | null;
  addressDeletionAlert: IAlert | null;
  documentsAlert: IAlert | null;
  attachmentAlert: IAlert | null;
  applicationProcessAlert: IAlert | null;
  printoutErrorLogAlert: IAlert | null;
  frtAlert: IAlert | null;
  modalAlert: IAlert | null;
}

export const initialState: IState = {
  roleAlert: null,
  dictionaryAlert: null,
  legalEntityAlert: null,
  legalEntityOrgAlert: null,
  legalEntityActivateAlert: null,
  legalEntityDeactivationWarningsAlert: null,
  taskAlert: null,
  intelligenceReportAlert: null,
  documentAlert: null,
  authAlert: null,
  userAlert: null,
  samePageAlert: null,
  apiAlert: null,
  nextPageAlert: null,
  transactionAlert: null,
  ancillaryAlert: null,
  trustedDeviceAlert: null,
  firearmAlert: null,
  accessoryAlert: null,
  ammunitionAlert: null,
  componentAlert: null,
  auditLogSamePageAlert: null,
  addressDeletionAlert: null,
  documentsAlert: null,
  attachmentAlert: null,
  applicationProcessAlert: null,
  printoutErrorLogAlert: null,
  frtAlert: null,
  modalAlert: null,
};

export const reducer = (state: IState, { type, payload }: IReducerAction) => {
  switch (type) {
    case ActionTypes.SET_ROLE_ALERT: {
      return { ...state, roleAlert: payload };
    }
    case ActionTypes.CLEAR_ROLE_ALERT: {
      return { ...state, roleAlert: null };
    }
    case ActionTypes.SET_DICTIONARY_ALERT: {
      return { ...state, dictionaryAlert: payload };
    }
    case ActionTypes.CLEAR_DICTIONARY_ALERT: {
      return { ...state, dictionaryAlert: null };
    }
    case ActionTypes.SET_USER_ALERT: {
      return { ...state, userAlert: payload };
    }
    case ActionTypes.CLEAR_USER_ALERT: {
      return { ...state, userAlert: null };
    }
    case ActionTypes.SET_LEGAL_ENTITY_ALERT: {
      return { ...state, legalEntityAlert: payload };
    }
    case ActionTypes.CLEAR_LEGAL_ENTITY_ALERT: {
      return { ...state, legalEntityAlert: null };
    }
    case ActionTypes.SET_API_ALERT: {
      return { ...state, apiAlert: payload };
    }
    case ActionTypes.CLEAR_API_ALERT: {
      return { ...state, apiAlert: null };
    }
    case ActionTypes.SET_LEGAL_ENTITY_ORG_ALERT: {
      return { ...state, legalEntityOrgAlert: payload };
    }
    case ActionTypes.CLEAR_LEGAL_ENTITY_ORG_ALERT: {
      return { ...state, legalEntityOrgAlert: null };
    }
    case ActionTypes.SET_LEGAL_ENTITY_ACTIVATE_ALERT: {
      return { ...state, legalEntityActivateAlert: payload };
    }
    case ActionTypes.CLEAR_LEGAL_ENTITY_ACTIVATE_ALERT: {
      return { ...state, legalEntityActivateAlert: null };
    }
    case ActionTypes.SET_LEGAL_ENTITY_DEACTIVATION_WARNINGS_ALERT: {
      return { ...state, legalEntityDeactivationWarningsAlert: payload };
    }
    case ActionTypes.CLEAR_LEGAL_ENTITY_DEACTIVATION_WARNINGS_ALERT: {
      return { ...state, legalEntityDeactivationWarningsAlert: null };
    }
    case ActionTypes.SET_AUTH_ALERT: {
      return { ...state, authAlert: payload };
    }
    case ActionTypes.CLEAR_AUTH_ALERT: {
      return { ...state, authAlert: null };
    }
    case ActionTypes.SET_SAME_PAGE_ALERT: {
      return { ...state, samePageAlert: payload };
    }
    case ActionTypes.CLEAR_SAME_PAGE_ALERT: {
      return { ...state, samePageAlert: null };
    }
    case ActionTypes.SET_NEXT_PAGE_ALERT: {
      return { ...state, nextPageAlert: payload };
    }
    case ActionTypes.CLEAR_NEXT_PAGE_ALERT: {
      return { ...state, nextPageAlert: null };
    }
    case ActionTypes.SET_TRANSACTION_ALERT: {
      return { ...state, transactionAlert: payload };
    }
    case ActionTypes.CLEAR_TRANSACTION_ALERT: {
      return { ...state, transactionAlert: null };
    }
    case ActionTypes.SET_ANCILLARY_ALERT: {
      return { ...state, ancillaryAlert: payload };
    }
    case ActionTypes.CLEAR_ANCILLARY_ALERT: {
      return { ...state, ancillaryAlert: null };
    }
    case ActionTypes.SET_TRUSTED_DEVICE_ALERT: {
      return { ...state, trustedDeviceAlert: payload };
    }
    case ActionTypes.CLEAR_TRUSTED_DEVICE_ALERT: {
      return { ...state, trustedDeviceAlert: null };
    }
    case ActionTypes.SET_FIREARM_ALERT: {
      return { ...state, firearmAlert: payload };
    }
    case ActionTypes.CLEAR_FIREARM_ALERT: {
      return { ...state, firearmAlert: null };
    }
    case ActionTypes.SET_ACCESSORY_ALERT: {
      return { ...state, accessoryAlert: payload };
    }
    case ActionTypes.CLEAR_ACCESSORY_ALERT: {
      return { ...state, accessoryAlert: null };
    }
    case ActionTypes.SET_AMMUNITION_ALERT: {
      return { ...state, ammunitionAlert: payload };
    }
    case ActionTypes.CLEAR_AMMUNITION_ALERT: {
      return { ...state, ammunitionAlert: null };
    }
    case ActionTypes.SET_COMPONENT_ALERT: {
      return { ...state, componentAlert: payload };
    }
    case ActionTypes.CLEAR_COMPONENT_ALERT: {
      return { ...state, componentAlert: null };
    }
    case ActionTypes.SET_AUDIT_LOG_SAME_PAGE_ALERT: {
      return { ...state, auditLogSamePageAlert: payload };
    }
    case ActionTypes.CLEAR_AUDIT_LOG_SAME_PAGE_ALERT: {
      return { ...state, auditLogSamePageAlert: null };
    }
    case ActionTypes.SET_ADDRESS_DELETION_ALERT: {
      return { ...state, addressDeletionAlert: payload };
    }
    case ActionTypes.CLEAR_ADDRESS_DELETION_ALERT: {
      return { ...state, addressDeletionAlert: null };
    }
    case ActionTypes.SET_ATTACHMENT_ALERT: {
      return { ...state, attachmentAlert: payload };
    }
    case ActionTypes.CLEAR_ATTACHMENT_ALERT: {
      return { ...state, attachmentAlert: null };
    }
    case ActionTypes.SET_APPLICATION_PROCESS_ALERT: {
      return { ...state, applicationProcessAlert: payload };
    }
    case ActionTypes.CLEAR_APPLICATION_PROCESS_ALERT: {
      return { ...state, applicationProcessAlert: null };
    }
    case ActionTypes.SET_PRINTOUT_ERROR_LOG_ALERT: {
      return { ...state, printoutErrorLogAlert: payload };
    }
    case ActionTypes.CLEAR_PRINTOUT_ERROR_LOG_ALERT: {
      return { ...state, printoutErrorLogAlert: null };
    }
    case ActionTypes.SET_DOCUMENTS_ALERT: {
      return { ...state, documentsAlert: payload };
    }
    case ActionTypes.CLEAR_DOCUMENTS_ALERT: {
      return { ...state, documentsAlert: null };
    }
    case ActionTypes.SET_FRT_ALERT: {
      return { ...state, frtAlert: payload };
    }
    case ActionTypes.CLEAR_FRT_ALERT: {
      return { ...state, frtAlert: null };
    }
    case ActionTypes.SET_TASK_ALERT: {
      return { ...state, taskAlert: payload };
    }
    case ActionTypes.CLEAR_TASK_ALERT: {
      return { ...state, taskAlert: null };
    }
    case ActionTypes.SET_INTELLIGENCE_REPORT_ALERT: {
      return { ...state, intelligenceReportAlert: payload };
    }
    case ActionTypes.CLEAR_INTELLIGENCE_REPORT_ALERT: {
      return { ...state, intelligenceReportAlert: null };
    }
    case ActionTypes.SET_MODAL_ALERT: {
      return { ...state, modalAlert: payload };
    }
    case ActionTypes.CLEAR_MODAL_ALERT: {
      return { ...state, modalAlert: null };
    }
    case ActionTypes.SET_DOCUMENT_ALERT: {
      return { ...state, documentAlert: payload };
    }
    case ActionTypes.CLEAR_DOCUMENT_ALERT: {
      return { ...state, documentAlert: null };
    }
    default:
      return state;
  }
};
